import { getChatTeasers } from '@sp/data/bif';
import { STREAM_CHAT_MODEL } from '@sp/feature/stream-chat';
import { createResource, waitUntilTrue } from '@sp/util/helpers';

export const CHAT_TEASERS_GLOBAL_MODEL = createResource((params?: { force: boolean }) => getChatTeasers(params));

waitUntilTrue(STREAM_CHAT_MODEL.$isInitialized).then(() => {
  STREAM_CHAT_MODEL.client.on('notification.added_to_channel', () => CHAT_TEASERS_GLOBAL_MODEL.load());
  STREAM_CHAT_MODEL.client.on('notification.removed_from_channel', () => CHAT_TEASERS_GLOBAL_MODEL.load());
});
